import { useMemo } from 'react';
import { EstimateResultInfoField } from './estimateResultInfoField';
import './repairEstimateResultStyle.css';
import { RepairRequestButtonField } from './repairRequestButtonField';
import { EstimateResultDataType } from '@/types/bodyAndPaint';

interface RepairEstimateResultProps {
  data: EstimateResultDataType;
  onClickCheckImage: () => void;
  onClickRepairSelect: () => void;
  onOpenInsuranceModal: () => void;
  onClickNoRepair: () => void;
}
export const RepairEstimateResult = ({
  data,
  onClickCheckImage,
  onClickRepairSelect,
  onOpenInsuranceModal,
  onClickNoRepair,
}: RepairEstimateResultProps) => {
  const {
    isInsurance,
    isEstimating,
    insuranceResultInfo,
    estimateInfo,
    estimateDetailList,
  } = useMemo(() => data ?? ({} as EstimateResultDataType), [data]);
  return (
    <div className={'repair-estimate-result-field'}>
      <EstimateResultInfoField
        onOpenInsuranceModal={onOpenInsuranceModal}
        onCheckImage={onClickCheckImage}
        insuranceResultInfo={insuranceResultInfo}
        estimateInfo={estimateInfo}
        detailList={estimateDetailList}
      />
      <RepairRequestButtonField
        isEstimating={isEstimating}
        isInsurance={isInsurance}
        onClickRepairSelect={onClickRepairSelect}
        onClickAddInsurance={onOpenInsuranceModal}
        onClickNoRepair={onClickNoRepair}
      />
    </div>
  );
};
